;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/:slug*\",\"regex\":\"^/(.+)$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false},{\"path\":\"/blog/:slug\",\"regex\":\"^/blog/([^/]+)$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false},{\"path\":\"/resources/:slug\",\"regex\":\"^/resources/([^/]+)$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false},{\"path\":\"/plugins/:slug\",\"regex\":\"^/plugins/([^/]+)$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/account/billing\"},{\"path\":\"/account/licenses\"},{\"path\":\"/account/projects\"},{\"path\":\"/account/registry\"},{\"path\":\"/account/settings\"},{\"path\":\"/forgot-password\"},{\"path\":\"/reset-password\"},{\"path\":\"/sign-in\"},{\"path\":\"/sign-in/cli\"},{\"path\":\"/sign-up\"},{\"path\":\"/\"},{\"path\":\"/blog\"},{\"path\":\"/changelog\"},{\"path\":\"/partners\"},{\"path\":\"/resources\"},{\"path\":\"/plugins\"}]}";globalThis["_sentryNextJsVersion"] = "16.0.1";import * as Sentry from '@sentry/nextjs'
import { initBotId } from 'botid/client/core'

// Define the paths that need bot protection.
// These are paths that are routed to by your app.
// These can be:
// - API endpoints (e.g., '/api/checkout')
// - Server actions invoked from a page (e.g., '/dashboard')
// - Dynamic routes (e.g., '/api/create/*')

initBotId({
  protect: [
    {
      path: '/contact',
      method: 'POST',
    },
    {
      path: '/plugins/*',
      method: 'POST',
    },
  ],
})

// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/
const sentryDsn = process.env.NEXT_PUBLIC_SENTRY_DSN

if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,

    // Add optional integrations for additional features
    integrations: [Sentry.replayIntegration()],

    // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
    tracesSampleRate: process.env.NEXT_PUBLIC_SENTRY_TRACES_SAMPLE_RATE
      ? parseFloat(process.env.NEXT_PUBLIC_SENTRY_TRACES_SAMPLE_RATE)
      : 1,

    // Enable logs to be sent to Sentry
    enableLogs: process.env.NEXT_PUBLIC_SENTRY_ENABLE_LOGS === 'true',

    // Define how likely Replay events are sampled.
    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 0.1,

    // Define how likely Replay events are sampled when an error occurs.
    replaysOnErrorSampleRate: 1.0,

    // Setting this option to true will print useful information to the console while you're setting up Sentry.
    debug: process.env.NEXT_PUBLIC_SENTRY_DEBUG === 'true',

    beforeSend(event, hint) {
      // Ignore 404 Not Found errors
      if (event.exception?.values?.[0]?.value?.includes('404')) {
        return null
      }
      if (event.request?.url && event.contexts?.response?.status_code === 404) {
        return null
      }
      return event
    },
  })
}

export const onRouterTransitionStart = sentryDsn ? Sentry.captureRouterTransitionStart : undefined
